import { styled } from '@mui/material'

export const Root = styled('div')`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 40px 0 0;
  width: 100%;
`

export const LogoCHC = styled('img')`
  margin-bottom: 48px;
`

export const Text = styled('h3')`
  color: ${props => props.theme.palette.brand.pickledBlueWood};
  font-size: 22px;
  line-height: 26px;
  font-weight: 300;
  margin: 0 0 0.5rem;
`

export const Image404 = styled('img')`
  margin: 48px auto;
  width: 100%;
  max-width: 500px;
  height: auto;
`
